import { defineComponent as _defineComponent } from 'vue'
import {
  IProductCostsDetails,
  IProductDetailsSection
} from '@/modules/catalog/services/products';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseIcon,
  BaseText,
  Heading,
  SpinnerLoader
} from '@warrenbrasil/nebraska-web';
import { PropType } from 'vue';
import ProductSideSheetSpreadDetails from '../ProductSideSheetSpreadDetails/ProductSideSheetSpreadDetails.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSideSheetDetails',
  props: {
  details: {
    type: Array as PropType<IProductDetailsSection[]>,
    default: null
  },
  costs: {
    type: Object as PropType<IProductCostsDetails>,
    default: null
  },
  loading: Boolean,
  error: Boolean
},
  emits: ['retry'],
  setup(__props, { emit }) {

const props = __props;



const COSTS_SECTION_TITLE = 'Custos';



return { __sfc: true,props, COSTS_SECTION_TITLE, emit, NebraskaColors, BaseIcon, BaseText, Heading, SpinnerLoader, ProductSideSheetSpreadDetails }
}

})